import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap' 
import 'bootstrap/dist/css/bootstrap.min.css';
import AlertIcon from 'vue-ionicons/dist/ios-alert.vue'
// OR using transpiled js version
// import AlertIcon from 'vue-ionicons/dist/js/ios-alert'
import AllIosIcon from 'vue-ionicons/dist/ionicons-ios.js'
import titleMixin from './mixins/titleMixin'
Vue.mixin(titleMixin)
 
Vue.use(AllIosIcon)
 
Vue.component('alert-icon', AlertIcon)

require('vue-ionicons/ionicons.css')


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')